import React from 'react'

import NewButton from '../ButtonNew'
import { BUTTON_VARIANT } from '../ButtonNew/ButtonNew'

export const HeaderAction = ({ action, variant = BUTTON_VARIANT.GREEN }) => {
  if (action && action?.label)
    return (
      <>
        {action?.url && (
          <NewButton url={action?.url} variant={variant} size={'md'}>
            {action?.label}
          </NewButton>
        )}
      </>
    )
  return null
}
